{
    "FormEngineNavigationElement": {
        "title": "Navigation"
    },
    "mask": {
        "FormEngineNavigationElement": {
            "groupTitle": "Navigation",
            "datasource": "Items",
            "datasourceExpressions": "Items Filter"
        }
    }
}